import { render, staticRenderFns } from "./SaveJxsc.vue?vue&type=template&id=ef4350fa&scoped=true&"
import script from "./SaveJxsc.vue?vue&type=script&lang=js&"
export * from "./SaveJxsc.vue?vue&type=script&lang=js&"
import style0 from "./SaveJxsc.vue?vue&type=style&index=0&id=ef4350fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4350fa",
  null
  
)

export default component.exports